import styled from 'styled-components';
import React, { useContext, useState } from 'react';
import { ListWrapper, Title, TitleHint } from './components';
import { EditorContext } from '../../../utils/contexts';
import { withEditorPageTracking } from '../../../shared/Tracking';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { FORM_GOALS } from '../constants';
import { FORM_GOAL_ICONS as GOAL_ICONS } from '../forms/constants';
import { buildFormGoalPayload } from '../forms/utils';

const GoalCard = styled.div`
  margin-bottom: 0.67em;
  transition: 0.3s;
  border: 2px solid #dcdcdc;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  &.active, &:hover { border-color: #636363; }
  h6 {
    padding-bottom: 0.25em;
    white-space: nowrap;
    font-size: 0.95em;
    line-height: 133%;
    color: #666;
    font-weight: 600;
  }
  p {
    font-size: 0.9em;
    line-height: 150%;
    color: #888;
    margin: 0;
  }
`;

const IconWrap = styled.div`
  padding: 8px 0 6px;
  display: flex;
  justify-content: center;
  color: #e8562a;
`;

function FormGoalStep({ className }) {
  const history = useHistory();
  const match = useRouteMatch();
  const { dispatch, settings, siteSettings } = useContext(EditorContext);
  const [active, setActive] = useState(settings.form_type);

  const onSelect = (goal) => {
    setActive(goal.form_type);
    dispatch({ type: 'update', payload: buildFormGoalPayload(goal, siteSettings) });

    const formId = match.params.formId || 'new';

    try {
      window.analytics?.track('Form Goal Changed', {
        form_type: goal.form_type,
        form_id: formId,
        site_id: match.params.siteId,
      });
    } catch (_) {}

    history.push(`/sites/${match.params.siteId}/forms/${formId}/layout`);
  };

  return (
    <div className={className}>
      <div>
        <Title>Goal</Title>
        <TitleHint>What kind of form do you want to create?</TitleHint>
      </div>
      <ListWrapper>
        {FORM_GOALS.map((goal) => {
          const Icon = GOAL_ICONS[goal.key];
          return (
            <GoalCard
              key={goal.key}
              className={active === goal.form_type ? 'active' : ''}
              onClick={() => onSelect(goal)}
            >
              <h6>{goal.label}</h6>
              {Icon && (
                <IconWrap>
                  <Icon style={{ fontSize: 40 }} />
                </IconWrap>
              )}
              <p>{goal.description}</p>
            </GoalCard>
          );
        })}
      </ListWrapper>
    </div>
  );
}

export default styled(withEditorPageTracking(FormGoalStep, 'Goal'))``;
